import { useABTest } from './useABTest';

export const useCheckoutV2ABTest = () =>
  useABTest(process.env.REACT_APP_CHECKOUT_EXPERIMENT_ID);
